import ScrollToTop from '@/pages/utils/ScrollToTop';
import AnimatedPage from '@/pages/utils/AnimatedPage';
import React, { useState } from 'react';
import 'yet-another-react-lightbox/styles.css';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import { Badge } from '@/components/ui/badge';
import ProjectNav from '@/pages/utils/ProjectNav';
import Footer from '@/pages/utils/Footer';
import { TextScramble } from '@/components/motion-primitives/text-scramble';
import { ArrowUpRight } from 'lucide-react';
import { ModeToggle } from '@/components/mode-toggle';
import LiquidGlassEffect from '@/pages/utils/LiquidGlassEffect';

const images = import.meta.glob('/public/project/real/ess-ksi/mobile/ss/*.webp', { eager: true });

export default function KSIESS() {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const imageArray = Object.keys(images).map((key) => ({
    src: images[key]?.default || images[key],
    title: key.split('/').pop().replace('.webp', ''),
  }));

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };

  return (
    <div>
      <ProjectNav />
      <ScrollToTop />
      <AnimatedPage>
        <div className='container mt-28 lg:mt-44 mb-12 lg:px-[400px]'>
          <div className='mt-16 md:mt-24'>
            <h1 className='text-4xl md:text-7xl font-semibold'>Employee Self Service</h1>
            <h1 className='text-xl font-thin mt-2 opacity-60'>Krakatau Sarana Infrastruktur</h1>
            <p className='my-4 opacity-60 font-base'>Collaboration with KSI, I helped build a mobile Employee Self Service (ESS) application that is used to facilitate employees' personal needs, such as permission, leave applications, salary checks, checking target points and online attendance at Krakatau Sarana Infrastruktur (KSI).</p>
          </div>
          <div className='flex flex-wrap gap-3 my-6 md:my-12'>
            <Badge className='rounded-full text-sm px-2'>UI/UX Design</Badge>
            <Badge className='rounded-full text-sm px-2'>App Design</Badge>
            <Badge className='rounded-full text-sm px-2'>Flutter</Badge>
            <Badge className='rounded-full text-sm px-2'>iOS</Badge>
            <Badge className='rounded-full text-sm px-2'>Andorid</Badge>
          </div>
        </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mt-1 md:mt-12 px-8 pb-24 pt-16">
            {imageArray.map((img, index) => (
              <div key={img.title} className="flex flex-col gap-1">
                <img
                  src={img.src}
                  alt={img.title}
                  className="shadow-lg rounded-lg cursor-pointer"
                  onClick={() => openLightbox(index)}
                />
                <p className="font-light text-xs text-stone-400 mt-2 capitalize">{img.title}</p>
              </div>
            ))}
          </div>
      </AnimatedPage>
      {/* <Footer /> */}

      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          slides={imageArray}
          index={currentImageIndex}
          plugins={[Captions]}
          on={{ view: ({ index }) => setCurrentImageIndex(index) }}
        />
      )}

      <div id="live-glass" className='text-black dark:text-white shadow-2xl z-[9] fixed bottom-12 left-1/2 -translate-x-1/2 px-2 py-1 text-center space-x-2 rounded-full'>
        <a href='https://play.google.com/store/apps/details?id=id.ptksi.ess&hl=id' target='_blank' className='flex items-center justify-between w-[130px] pl-2'>
            <TextScramble className='font-mono text-sm uppercase'>
              Live App
            </TextScramble>
            <button
                className='rounded-full p-2 font-semibold flex gap-x-2 items-center cursor-pointer'
            >
                <ArrowUpRight className='h-5' />
            </button>
        </a>
        <LiquidGlassEffect targetSelector="#live-glass" width={200} height={64} />
      </div>

      <div className='fixed bottom-12 right-12'>
        <ModeToggle />
      </div>
    </div>
  )
}
